import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css']
})
export class SectionComponent implements OnInit {

  isCollapsed: boolean;
  constructor() { }

  ngOnInit(): void {
    this.isCollapsed = true;
  }
  onSendMail(){
    var mail = document.createElement("a");
    mail.href = "mailto:nicoalani.dev@gmail.com";
    mail.click();
  }

}
